var getBuiltIn = require('../internals/get-built-in');
var setToStringTag = require('../internals/set-to-string-tag');

var DOM_EXCEPTION = 'DOMException';

setToStringTag(getBuiltIn(DOM_EXCEPTION), DOM_EXCEPTION);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/web.dom-exception.to-string-tag.js
// module id = 548
// module chunks = 0